import { useState, useCallback, useMemo } from "react";
import { useDispatch,useSelector } from "react-redux";
import { approvePublicApiUser } from "./approvePublicApiUserSlice";
import useNotification from "../../../../../components/notification/useNotification";
import { isSuccessResponse } from "../../../../../common/utils";
import { fetchOrganizationData } from "../../../listOrganizationSlice";
import { actions as spinnerActions } from "../../../../../components/ui/spinner/spinnerSlice";
import { Status } from "../../../../../common/constants";
interface IProps {
  email: string;
  isApproved: boolean;
  orgId: string;
}

const useEnableDisablePublicApi = ({ email, isApproved, orgId }: IProps) => {
  const [show, setShow] = useState(false);
  const dispatch: any = useDispatch();
  const { showSuccessNotification, showWarningNotification } =
    useNotification();

  const popupAction = useMemo(
    () => (isApproved ? "Disable" : "Enable"),
    [isApproved]
  );
  const popupTitle = `${popupAction} Public API Access`;

  const handleShow = useCallback(() => setShow(true), []);
  const handleClose = useCallback(() => setShow(false), []);

  const handleToggle = useCallback(async () => {
    dispatch(spinnerActions.setApiStatus(Status.PENDING));
    dispatch(
      approvePublicApiUser({ orgAdminEmail: email, isSuperAdminApproved: !isApproved, orgId })
    ).then((response) => {
      if (isSuccessResponse(response.payload)) {
        showSuccessNotification(response.payload.message);
        dispatch(spinnerActions.setApiStatus(Status.SUCCESS));
        dispatch(fetchOrganizationData());
      } else {
        dispatch(spinnerActions.setApiStatus(Status.FAILED));
        showWarningNotification(response.payload);
      }
    });
    setShow(false);
  }, [
    dispatch,
    email,
    isApproved,
    showSuccessNotification,
    showWarningNotification,
  ]);

  return {
    show,
    handleShow,
    handleClose,
    popupAction,
    popupTitle,
    handleToggle,
  };
};

export default useEnableDisablePublicApi;
